import { gql } from '@apollo/client';

const MAINTENANCE_DEVICES_FRAGMENT = gql`
  fragment MaintenanceDevices on Device {
    id
    deviceId
    status
    model
    firstStudyDate
    additionalStatus
    isRunningStudy
    isRenewal
    lastSync {
      time
      networkMode
      isCharging
      rssi
      fwVersion
      schema
    }
    facility {
      id
      name
      status
      programs {
        protectPlus
        renewalStock
      }
    }
    canRunBiotresMCT
  }
`;

export default MAINTENANCE_DEVICES_FRAGMENT;
